"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Progress as ProgressPrimitive } from "radix-ui";
import { cn } from "./lib/utils.js";
/**
 * Hand-written rather than `shadcn add progress` (block 06 override 5): the
 * CLI's file imports `@radix-ui/react-progress`, and this package standardised
 * on the unified `radix-ui` entrypoint that every other component here uses.
 * Same markup, one dependency.
 */
function Progress({ className, value, ...props }) {
    return (_jsx(ProgressPrimitive.Root, { "data-slot": "progress", className: cn("bg-primary/20 relative h-2 w-full overflow-hidden rounded-full", className), value: value, ...props, children: _jsx(ProgressPrimitive.Indicator, { "data-slot": "progress-indicator", className: "bg-primary h-full w-full flex-1 transition-transform", style: { transform: `translateX(-${100 - (value ?? 0)}%)` } }) }));
}
export { Progress };
//# sourceMappingURL=progress.js.map